<template>
    <!-- This will render the author names simple or with a modal (for Editor), and allow for a slot for other badges like "Has other submissions to company" -->

    <div class="font-weight-bolder dm-top-details-single dm-top-details-single-author mb-2 text-dark-75 w-100">

        <!-- Editor View -->
        <AuthorNameAndContactDetailsModal
            v-if="submission.author_contact_details"
            :submission_id="submission.id"
            :contact_details="submission.author_contact_details"
        />

        <span v-else-if="submission.content && submission.content.author_names">
            <span class="svg-icon svg-icon-md svg-icon-dark-75 mr-1">
                <PersonSvg />
            </span>
            {{ submission.content.author_names }}
        </span>

        <slot></slot>
    </div>
</template>

<script>
import AuthorNameAndContactDetailsModal from "./partials/AuthorNameAndContactDetailsModal.vue";
import PersonSvg from "@/svg/PersonSvg.vue";

export default {
    components: { AuthorNameAndContactDetailsModal, PersonSvg },

    props: ["submission"]
}
</script>
